import { OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { useEffect, useRef, useState } from 'react';
import { delay } from 'shared-base';
import { Model } from './PageWireframes.components';
import { downloadDataUrl, loadModelAndWait, recordVideo } from './PageWireframes.utils';

const TOTAL_MODELS = 413;

const ignoreIndexes = [7, 37, 150, 162, 219, 229, 264, 279, 290, 336, 356, 407, 408, 412];

export function PageWireframes() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const controlsRef = useRef<any>();
  const [currentIndex, setCurrentIndex] = useState(247);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (!isProcessing) processNext();
  }, [currentIndex]);

  const processNext = async () => {
    if (currentIndex > TOTAL_MODELS) {
      console.log('All models processed.');
      return;
    }
    setIsProcessing(true);
    const modelId = `G-${String(currentIndex).padStart(3, '0')}`;

    const canvas = canvasRef.current!;
    await loadModelAndWait(modelId);
    await delay(1000); // stabilize the render

    // Screenshot
    const image = canvas.toDataURL('image/png');
    downloadDataUrl(image, `${modelId}.png`);

    // Video
    await recordVideo(canvas, `${modelId}.webm`, 3000); // 3s video

    setCurrentIndex((i) => {
      let nextIndex = i + 1;
      while (ignoreIndexes.includes(nextIndex)) nextIndex++;
      return nextIndex;
    });

    setIsProcessing(false);
  };

  return (
    <Canvas
      ref={canvasRef}
      camera={{ fov: 45 }}
      gl={{ preserveDrawingBuffer: true }}
      onCreated={({ gl }) => {
        gl.setSize(800, 800); // Optional: uniform resolution
      }}
    >
      <ambientLight intensity={0.5} />
      <directionalLight position={[5, 5, 5]} intensity={1} />
      <OrbitControls ref={controlsRef} />
      <Model id={`G-${String(currentIndex).padStart(3, '0')}`} controlsRef={controlsRef} />
    </Canvas>
  );
}

export default PageWireframes;
